import { useState, useCallback, useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import mensajeriaService from '../services/mensajeriaService';

// Total de mensajes de WhatsApp no leídos (suma de noLeidosTotal de todos los trámites).
// Extraído del bloque inline que tenía components/NavegacionLateral.js para que la navegación
// desktop y la mobile lean la misma fuente sin duplicar el poller de 15s.
//
// No hay bandeja de WhatsApp propia dentro de la campana (desktop ni mobile): el botón abre
// el panel derecho de herramientas (AdminRightSidebar) vía CustomEvent — abrirPanel() dispara
// ese mismo evento, para no duplicar el string 'openAdminSidebar' en cada consumidor.
export default function useNotificacionesWhatsApp() {
    const { user } = useAuth();
    const [totalNoLeidos, setTotalNoLeidos] = useState(0);

    const refrescar = useCallback(async (event) => {
        if (!user) return;

        const totalDesdeEvento = Number(event?.detail?.total);
        if (Number.isFinite(totalDesdeEvento) && totalDesdeEvento >= 0) {
            setTotalNoLeidos(totalDesdeEvento);
            return;
        }

        try {
            const tramites = await mensajeriaService.listarTramites();
            const total = (Array.isArray(tramites) ? tramites : [])
                .reduce((acc, t) => acc + Number(t.noLeidosTotal || 0), 0);
            setTotalNoLeidos(total);
        } catch {
            setTotalNoLeidos(0);
        }
    }, [user]);

    useEffect(() => {
        if (!user) {
            setTotalNoLeidos(0);
            return;
        }

        refrescar();
        const interval = setInterval(refrescar, 15000);
        window.addEventListener('whatsappChatsUpdated', refrescar);
        window.addEventListener('whatsappUnreadCountChanged', refrescar);

        return () => {
            clearInterval(interval);
            window.removeEventListener('whatsappChatsUpdated', refrescar);
            window.removeEventListener('whatsappUnreadCountChanged', refrescar);
        };
    }, [user, refrescar]);

    const abrirPanel = useCallback(() => {
        window.dispatchEvent(new CustomEvent('openAdminSidebar', { detail: { tab: 'whatsapp' } }));
    }, []);

    return { totalNoLeidos, abrirPanel };
}
